var map = {
	"./Switch.svg": 298,
	"./alert-icons/alert-icon-1.svg": 633,
	"./alert-icons/alert-icon-10.svg": 173,
	"./alert-icons/alert-icon-11.svg": 634,
	"./alert-icons/alert-icon-12.svg": 174,
	"./alert-icons/alert-icon-2.svg": 635,
	"./alert-icons/alert-icon-3.svg": 636,
	"./alert-icons/alert-icon-4.svg": 637,
	"./alert-icons/alert-icon-5.svg": 638,
	"./alert-icons/alert-icon-6.svg": 639,
	"./alert-icons/alert-icon-7.svg": 640,
	"./alert-icons/alert-icon-8.svg": 641,
	"./alert-icons/alert-icon-9.svg": 642,
	"./autofact-logo-new.svg": 88,
	"./autofact-logo-white.svg": 643,
	"./autofact-logo.svg": 644,
	"./cameraRecord.svg": 299,
	"./card-identity-type-new.png": 175,
	"./card-identity-type-old.png": 176,
	"./check-purple.svg": 645,
	"./check-v2.svg": 646,
	"./check.svg": 62,
	"./checklist.svg": 70,
	"./ci-antigua-ejemplo-back.png": 300,
	"./ci-antigua-ejemplo-front.png": 301,
	"./ci-back-ejemplo.jpg": 302,
	"./ci-back-new.svg": 647,
	"./ci-back.svg": 648,
	"./ci-ejemplo.jpg": 303,
	"./ci-front.svg": 649,
	"./claveunica.svg": 177,
	"./clock-icon.svg": 178,
	"./close.svg": 650,
	"./close_new.svg": 179,
	"./document-new.svg": 651,
	"./download-new.svg": 652,
	"./face-verification.svg": 180,
	"./face.svg": 653,
	"./fingerprint.svg": 181,
	"./front-card.svg": 182,
	"./ic-alert-modal.svg": 89,
	"./ic-back.svg": 654,
	"./ic-background.png": 655,
	"./ic-background.svg": 656,
	"./ic-camera-modal.svg": 183,
	"./ic-error-modal.svg": 90,
	"./ic-front.svg": 657,
	"./ic-instruction-01.svg": 658,
	"./ic-instruction-02.svg": 659,
	"./ic-instruction-03.svg": 660,
	"./ic-instruction-04.svg": 661,
	"./ic-instruction-05.png": 662,
	"./ic-instruction-05.svg": 663,
	"./ic-instruction-06.svg": 664,
	"./ic-instruction-07.svg": 665,
	"./ic-instruction-08.svg": 666,
	"./ic-instruction-09.svg": 667,
	"./ic-instruction-10.svg": 668,
	"./ic-instruction-11.svg": 669,
	"./ic-instruction-12.svg": 670,
	"./ic-instruction-13.svg": 671,
	"./ic-instruction-14.svg": 672,
	"./ic-instruction-15.svg": 673,
	"./ic-lightbulb.svg": 674,
	"./ic-unique-key-description.svg": 184,
	"./information-cirlce-gray.svg": 113,
	"./loading.gif": 675,
	"./logo-ecert-azul.svg": 676,
	"./logo-ecert-color.svg": 677,
	"./logo.svg": 678,
	"./logo_ecert.svg": 679,
	"./mandate.svg": 680,
	"./new-ci-back-ejemplo-2.jpeg": 304,
	"./new-ci-back-ejemplo.jpg": 681,
	"./new-ci-front-ejemplo.jpg": 305,
	"./notary-declaration.svg": 185,
	"./ok-circle.svg": 186,
	"./phosphoricons-clock-clockwise.svg": 187,
	"./red-cross.svg": 682,
	"./redirect.svg": 683,
	"./signature-new.svg": 684,
	"./signature.svg": 188,
	"./times-circle-solid.svg": 91,
	"./tio-emilio-icon.png": 172,
	"./turn-phone.svg": 685,
	"./turncamera.svg": 165,
	"./unique_key_description.svg": 60,
	"./warning-circle.svg": 189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;